import type {
    EmbeddedMenuUnsupportedPropsConstantType,
    EmbeddedMenuPressablePropsConstantType,
    EmbeddedMenuUnsupportedPropKey,
    EmbeddedMenuPressableProps,
    EmbeddedMenuMappedPropKey
} from "./type";
import type IRowCardProps from "../rowCard/type";

export const EMBEDDED_MENU_UNSUPPORTED_PROPS: Array<EmbeddedMenuUnsupportedPropKey> = [
    "rightContentContainerStyle",
    "leftContentContainerStyle",
    "isTransparentBackground",
    "subTitleNumberOfLines",
    "rightSubTitleVariant",
    "rightContainerStyle",
    "rightSubTitleColor",
    "rightSubTitleStyle",
    "titleNumberOfLines",
    "leftContainerStyle",
    "leftSubTitleStyle",
    "rightTitleVariant",
    "rightTitleColor",
    "subTitleVariant",
    "rightTitleStyle",
    "backgroundColor",
    "renderTrailing",
    "leftTitleStyle",
    "rightIconStyle",
    "subTitleColor",
    "rightSubTitle",
    "renderLeading",
    "titleVariant",
    "borderRadius",
    "titleColor",
    "rightTitle",
    "iconColor",
    "iconStyle",
    "isLoading",
    "iconSize",
    "isInList",
    "type"
];

const EMBEDDED_MENU_MAPPED_PROPS: Array<EmbeddedMenuMappedPropKey> = [
    "customTheme",
    "isSelected",
    "isDisabled",
    "rightIcon",
    "subTitle",
    "onPress",
    "style",
    "title",
    "icon"
];

export const getEmbeddedMenuPressableProps = ({
    props
}: EmbeddedMenuPressablePropsConstantType): EmbeddedMenuPressableProps => {
    const pressableProps: Partial<IRowCardProps> = {
        ...props
    };

    [
        ...EMBEDDED_MENU_UNSUPPORTED_PROPS,
        ...EMBEDDED_MENU_MAPPED_PROPS
    ].forEach((key) => {
        delete pressableProps[key];
    });

    return pressableProps;
};

export const getEmbeddedMenuUnsupportedProps = ({
    buttons
}: EmbeddedMenuUnsupportedPropsConstantType): Array<EmbeddedMenuUnsupportedPropKey> => {
    const unsupportedProps = buttons.flatMap((buttonItem) => [
        ...EMBEDDED_MENU_UNSUPPORTED_PROPS.filter((key) => buttonItem.props?.[key] !== undefined),
        ...getEmbeddedMenuUnsupportedProps({
            buttons: buttonItem.subButtons ?? []
        })
    ]);

    return Array.from(new Set(unsupportedProps));
};
